/**
 * BH Zip Landing Page
 *
 * Handles the entry → result animation and "check another zip" reset.
 * Zip code lookup logic and Klaviyo integration are handled separately.
 */
(function () {
  var form = document.querySelector('[data-zip-form]');
  var entryEl = document.querySelector('[data-zip-entry]');
  var resultEl = document.querySelector('[data-zip-result]');
  var resetBtn = document.querySelector('[data-zip-reset]');

  if (!form || !entryEl || !resultEl) return;

  /**
   * Show a specific result state by key.
   * Hank's zip logic should call this via:
   *   window.bhZipLanding.showResult('available_now')
   *   window.bhZipLanding.showResult('coming_soon', { date: 'the week of March 10' })
   */
  function showResult(stateKey, options) {
    options = options || {};

    // Hide all result states
    var states = resultEl.querySelectorAll('[data-result]');
    for (var i = 0; i < states.length; i++) {
      states[i].hidden = true;
    }

    // Show the matching one
    var target = resultEl.querySelector('[data-result="' + stateKey + '"]');
    if (target) {
      target.hidden = false;
    }

    // Fill in the dynamic launch date (coming_soon carries one; the lookup
    // is scoped to the state being shown).
    if (options.date && target) {
      var dateEl = target.querySelector('[data-coming-soon-date]');
      if (dateEl) {
        dateEl.textContent = options.date;
      }
    }

    // Animate: fade out entry, fade in result
    entryEl.classList.add('is-exiting');

    entryEl.addEventListener('animationend', function onExit() {
      entryEl.removeEventListener('animationend', onExit);
      entryEl.hidden = true;
      entryEl.classList.remove('is-exiting');

      resultEl.style.opacity = '0';
      resultEl.hidden = false;
      // Force reflow so opacity:0 applies before animation starts
      void resultEl.offsetHeight;
      resultEl.style.opacity = '';
      resultEl.classList.add('is-entering');

      resultEl.addEventListener('animationend', function onEnter() {
        resultEl.removeEventListener('animationend', onEnter);
        resultEl.classList.remove('is-entering');
      });
    });
  }

  /**
   * Reset back to the entry state with email pre-filled.
   */
  function resetToEntry() {
    var emailInput = form.querySelector('[name="email"]');
    var zipInput = form.querySelector('[name="zip_code"]');
    var savedEmail = emailInput ? emailInput.value : '';

    // Hide result, show entry
    resultEl.hidden = true;
    entryEl.hidden = false;
    entryEl.classList.add('is-entering');

    entryEl.addEventListener('animationend', function onEnter() {
      entryEl.removeEventListener('animationend', onEnter);
      entryEl.classList.remove('is-entering');
    });

    // Pre-fill email, clear zip, focus zip
    if (emailInput) emailInput.value = savedEmail;
    if (zipInput) {
      zipInput.value = '';
      zipInput.focus();
    }
  }

  // Reset button
  if (resetBtn) {
    resetBtn.addEventListener('click', resetToEntry);
  }

  // Form submission — prevent default, let Hank's code handle lookup + Klaviyo.
  // For now, shows a placeholder result so the animation is testable.
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // If Hank's lookup function exists, call it. Otherwise show placeholder.
    if (typeof window.bhZipLanding !== 'undefined' && typeof window.bhZipLanding.onSubmit === 'function') {
      window.bhZipLanding.onSubmit(form);
    } else {
      // Placeholder: show available_now so the animation is testable
      showResult('available_now');
    }
  });

  // Expose API for Hank's zip logic to call
  window.bhZipLanding = window.bhZipLanding || {};
  window.bhZipLanding.showResult = showResult;
  window.bhZipLanding.resetToEntry = resetToEntry;
})();
